import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.se.order.subject]: 'TELCOBI VTL Error TELCO',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI VTL Riesgo Error 800',
      [STRING_KEYS.se.shippingMobileInsurance.subject]: 'TELCOBI - COMPRA SEGURO TERMINAL LIBRE',
      [STRING_KEYS.process.title]: '',
      [STRING_KEYS.summary.title]: '',
      [STRING_KEYS.summary.mandatoryFieldsModal.title]: 'Campos obligatorios',
      [STRING_KEYS.summary.mandatoryFieldsModal.subTitle]: 'Por favor revisa el formulario, hay campos obligatorios sin completar.',
      [STRING_KEYS.shipment.text]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos.',
      [STRING_KEYS.shipment.secondaryText]: '',
      [STRING_KEYS.shipment.prePurchaseText]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos. A partir de fin del periodo de reserva.',
      [STRING_KEYS.shipment.prePurchaseSecondaryText]: '',
      [STRING_KEYS.summary.paymentCard.title]: 'Forma de pago',
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.fundedPayment.label]: 'Financiado',
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.fundedPayment.children.subtitle]: 'Cuota de financiación',
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.fundedPayment.children.box.line1]: 'en {months} cuotas',
      // eslint-disable-next-line max-len
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.fundedPayment.children.p1]: 'Coste de apertura: {openingCost}. Importe a financiar: {price}. Coste de crédito: {totalTaxes}. Total adeudado: {totalAmount}. Oferta financiera realizada por CaixaBank Payments & Consumer, E.F.C., E.P., S.A. y sujeta a su aprobación. TIN: {tin}%, TAE: {tae}%. Válida hasta {financialEndDate} ',
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.fundedPayment.children.p2]: 'La cuota mensual resultante de la financiación se incluirá en la factura Movistar de la línea móvil.',
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.cardPayment.label]: 'Pago con tarjeta',
      [STRING_KEYS.summary.paymentCard.paymentRadioItem.cardPayment.children.description]: 'Se realizará en un único pago al final de este proceso de compra.',
      [STRING_KEYS.cardPayment.visaImg]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/tarj-credito-visa.jpg',
      [STRING_KEYS.cardPayment.masterCardImg]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/tarj-credito-mastercard.jpg',
      [STRING_KEYS.cardPayment.title]: 'Pago con tarjeta',
      [STRING_KEYS.cardPayment.infoBar]: 'Introduce los datos de tu tarjeta',
      [STRING_KEYS.cardPayment.infoBarIcon]: 'TarjetaCredito',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.CARD]]: 'A pagar con tarjeta',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.FUNDED]]: 'Financiado',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]]: 'Financiado',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]]: 'Financiado',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceText[CQ_POTS.PAYMENT_POT.CARD]]: 'Pago con tarjeta',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceText[CQ_POTS.PAYMENT_POT.FUNDED]]: 'Cuota de financiación',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceText[CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]]: 'Cuota de financiación',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceText[CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]]: 'Cuota de financiación',
      [STRING_KEYS.summary.cart.mobileInsuranceTitle]: 'Cuota mensual en factura Movistar',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
      [STRING_KEYS.shipment.new]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {
      [STRING_KEYS.se.order.subject]: 'TELCOBI VTL Error TELCO AU',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI VTL Riesgo Error 800 AU',
      [STRING_KEYS.se.shippingMobileInsurance.subject]: 'TELCOBI - COMPRA SEGURO TERMINAL LIBRE AU',
    },
  },
};
